<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kJkdlL/tc-custom/9781617451614.jpg?1737668485820" alt="This image is the cover for the book Gorgeous Wool Appliqué"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gorgeous Wool Appliqué
      </h1>
      <p class="bookDescription body article font2">
        <b>“There's more to felted wool appliqué than folk art, as needle artist Tirico demonstrates in this collection of colorful projects.” —<i>Library Journal </i></b><br/><br/>Sewing with luxurious felted wool, discover the secrets to dimensional appliqué that will add depth and drama to your home decor. Take your embroidery skills to the next level with eight colorful projects including penny rugs, pincushions, and pillows. <br/><br/>Easy-to-learn techniques such as thread-matching, needle-slanting, and fabric-layering will help you achieve clean and sharp lines every time! This clear, visual guide includes links to printable, full size patterns with placement and embroidery guides.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deborah Gale Tirico
      </h2>
      
      <p class="authorDescription body article">Deborah Gale Tirico Bio: Deborah Gale Tirico is an avid needle artist and graphic designer. An active member of The Embroiderer’s Guild of America, she regularly teaches felt wool appliqué at guilds, events, and festivals across the United States. Deborah lives in Pennsylvania. deborahtirico.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing, Inc
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?be106fdc